export const interests = [
  { value: "product-manager", label: "Product Manager" },
  { value: "lecturer-researcher", label: "Lecturer / Researcher" },
  { value: "it-specialist", label: "IT Specialist" },
  { value: "bim", label: "BIM" },
  { value: "indoor-lighting", label: "Indoor Lighting" },
  { value: "outdoor-lighting", label: "Outdoor Lighting" },
  { value: "tunnel-lighting", label: "Tunnel Lighting" },
  { value: "daylight", label: "Daylight" },
  { value: "emergency-lighting", label: "Emergency Lighting" },
  { value: "visualisations", label: "Visualisations" },
  { value: "sports-lighting", label: "Sports Lighting" },
  { value: "standards-norms", label: "Standards / Norms" },
  { value: "pir-sensors", label: "PIR Sensors" },
  { value: "energy-efficiency-sustainability", label: "Energy Efficiency / Sustainability" },
  { value: "glare-assessment-obtrusive-light", label: "Glare Assessment / Obtrusive Light" },
]